import React from 'react';

export const Scenarios = React.lazy(() => import('./Scenarios'));
export const CustomStressScenarios = React.lazy(() => import('./CustomStressScenarios'));
export const ScenarioValidation = React.lazy(() => import('./ScenarioValidation'));
export const ForecastAssumptions = React.lazy(() => import('./ForecastAssumptions'));
export const CREForecastAssumptions = React.lazy(() => import('./CREForecastAssumptions'));
export * from './getReleaseNotes';
